// import InputGroup from "../../../../components/FormComponent/InputGroup";
import Layout from "../../../../components/Layout";
import BreadCrumb from "../../../../components/BreadCrumb";
import { toast } from "react-toastify";
import Button from "../../../../components/Button";
import useStyles from "../../styles";
import PaymentCard from "../../../../components/CardCount/PaymentCard";
import { TableSearch } from "../../../../components/Table/TableActions";
import Table from "../../../../components/Table/Table";
import Modal from "../../../../components/Modal";
import { Icon } from "@iconify/react/dist/iconify.js";
// import PaymentRow from "./PaymentRow";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import Badge from "../../../../components/Badge";
import {
  // Table as GridTable,
  // TableBody,
  // TableCell,
  // TableContainer,
  // TableFooter,
  // TableHead,
  // TableRow,
  // Paper,
  Grid
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
// import { Discount } from "../../../../utils/DropDown";
import { httprequest } from "../../../../data/api";
import { useEffect, useState, useCallback } from "react";
import PageLoader from "../../../../components/PageLoader";
import useWindowSize from "../../../../hooks/useWindow";

const ALL_INVOICES = "/api/v1/invoices";
const SCHOOL_DISCOUNTS = "/api/v1/discounts";
const APPLY_DISCOUNT = "/api/v1/invoices/student-invoices/discounts/apply";
// const STUDENT_INVOICE = "/api/v1/student-invoice";

const PreviewInvoice = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const classes = useStyles();
  // const { appLogo } = useUserState();
  const [isGettingDiscounts, setIsGettingDiscounts] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [invoice, setInvoice] = useState({});
  const [studentinvoice, setStudentsInvoice] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [discountModal, setDiscountModal] = useState(false);
  const [discountItems, setDiscountItems] = useState([]);
  const width = useWindowSize();
  const mobile = width < 600;

  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);

  // Handle row selection from the table
  const handleRowSelected = useCallback((state) => {
    const selectedRows = state?.selectedRows || [];
    const invoiceNos = selectedRows.map(row => row.invoice_no).filter(Boolean);
    setSelectedInvoices(invoiceNos);
  }, []);

  const handleDiscountModal = () => {
    setDiscountModal(!discountModal);
  };

  /**
     * Fetches all invoice items from the server.
     * @function
     * @description Makes a GET request to SCHOOL_DISCOUNTS endpoint and updates the invoice items state.
     */
  const getAllDiscounts = () => {
    setIsGettingDiscounts(true);
    httprequest
      .get(SCHOOL_DISCOUNTS)
      .then((res) => {
        setDiscountItems(res?.data?.data);
        setIsGettingDiscounts(false);
      }).catch((err) => {
        setIsGettingDiscounts(true);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Fetches class invoices for all students
 * @function getStudentClassInvoice
 * @async
 * @description Retrieves invoice data for a class including student list and sets loading state
 * @throws {Error} Silently handles errors and stops loading indicator
 */
  const getStudentClassInvoice = () => {
    setIsLoading(true);
    httprequest
      .get(`${ALL_INVOICES}/${id}`)
      .then((res) => {
        setInvoice(res?.data?.data);
        setStudentsInvoice(res?.data?.data?.students);
        setSearchResult(res?.data?.data?.students);
        setIsLoading(false);
      }).catch(() => {
        setIsLoading(false);
      });
  };

  const handleApplyDiscount = () => {
    const payload = {
      discount_id: selectedDiscount.id,
      invoice_nos: selectedInvoices
    };

    httprequest.patch(APPLY_DISCOUNT, payload)
      .then((res) => {
        toast.success(res?.data?.message);
        handleDiscountModal();
        setSelectedInvoices([]);
        setSelectedDiscount(null);
        getStudentClassInvoice();
      }).catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Fetches a specific student's invoice details
 * @function getStudentInvoice
 * @async
 * @param {string} invoice_no - The invoice number to fetch
 * @description Retrieves detailed invoice data for a specific student
 * @throws {Error} Silently handles errors and stops loading indicator
 */
  // const getStudentInvoice = (invoice_no) => {
  //   setIsStudentInvoiceLoading(true);
  //   httprequest
  //     .get(`${STUDENT_INVOICE}/${invoice_no}`)
  //     .then((res) => {
  //       setAStudentInvoice(res?.data?.data);
  //       setIsStudentInvoiceLoading(false);
  //     }).catch(() => {
  //       setIsStudentInvoiceLoading(false);
  //     });
  // };

  /**
 * Closes cancel modal and navigates back to invoices page
 * @function handleCloseCancelModal
 */
  const handleCloseCancelModal = () => {
    setCancelModal(false);
    navigate("/payment/invoice");
  };

  /**
 * Toggles invoice modal and fetches student invoice data
 * @function handleInvoiceModal
 * @param {Object} row - The invoice row data containing invoice_no
 */
  // const handleInvoiceModal = (row) => {
  //   getStudentInvoice(row?.invoice_no);
  //   setInvoiceModal(!invoiceModal);
  // };

  /**
 * Closes the invoice detail modal
 * @function handleCloseInvoiceModal
 */
  // const handleCloseInvoiceModal = () => {
  //   setInvoiceModal(false);
  // };

  /**
 * Table columns configuration for student invoices
 * @type {Array<Object>} columns
 * @property {string} name - Column header text
 * @property {Function} selector|cell - Cell content renderer
 * @property {boolean} [center] - Center align content
 * @property {boolean} [sortable] - Enable/disable sorting
 */
  const columns = [
    {
      name: "Invoice No.",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Invoice No</p>}
          {row?.invoice_no || "--/--"}
        </>
      )
    },
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Classes</p>}
          {`${row?.student?.last_name || "--/--"} ${row?.student?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Amount",
      selector: () => (
        <>
          {mobile && <p className="mobile-styling">Amount</p>}
          {invoice?.total}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={row?.status} />
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button onClick={() => navigate(`/payment/invoice-details/${row?.invoice_no}`)} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </button>
          {/* <button className="table-action-icon delete-icon" onClick={() => handleDeleteModal(row)}>
            <Icon icon="mingcute:delete-2-line" />
          </button> */}
        </div>
      )
    }
  ];

  /**
 * Fetches class invoices on component mount
 * @effect
 * @listens Mount
 */
  useEffect(() => {
    getStudentClassInvoice();
    getAllDiscounts();
  }, []);

  /**
 * Handles student invoice search functionality
 * @function handleSearchStudentInvoice
 * @param {Object} e - The input change event
 * @description Filters invoices based on multiple search terms across various fields
 */
  const handleSearchStudentInvoice = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = studentinvoice?.filter((data) => valArray?.every(
      (word) => data?.status
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                            data?.invoice_no
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                            data?.student?.first_name
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                            data?.student?.last_name
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                              data?.class?.name
                                ?.toLowerCase()
                                .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/payment/overview"
                link_one_name="Payments"
                link_two="/payment/invoice"
                link_two_name="Invoice"
                active={invoice?.invoice_name || "--/--"}
                description="Preview your invoice before sending"
              />
            </div>
          </div>
          <div>
            {isLoading ? <PageLoader /> : (
              <>
                <div className="page-content padding-equal margin-bottom-14">
                  <div className={`${classes.previewheader} margin-bottom text-align-left`}>
                    <div>
                      <p className="text-align-left">Invoice Name</p>
                      <h4>{invoice?.invoice_name || "--/--"}</h4>
                    </div>
                    <div className="text-align-right">
                      <p className="text-align-left-413">Amount</p>
                      <h3>{`${invoice?.currency || "NGN"} ${invoice?.total?.toLocaleString() || 0}`}</h3>
                    </div>
                  </div>
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={4} sm={4} xs={6}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Session</p>
                          <h4>{invoice?.session?.session || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={6}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Term</p>
                          <h4>{invoice?.term?.term || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={6}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>For</p>
                          <h4>{invoice?.structure_type || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Invited To</p>
                          <h4 className="text-align-left">
                            {invoice?.structure_type === "student" ? (
                              invoice?.students?.map((all, i) => {
                                return (
                                  <h4 className="key-pair-value text-align-left" key={i}>{`${all?.student?.last_name || "--/--"} ${all?.student?.first_name || "--/--"}`}</h4>
                                );
                              })
                            ) : invoice?.structure_type === "subject" ? (
                              <>
                                {invoice?.subject?.name || "--/--"}
                              </>
                            ) : invoice?.structure_type === "class" ? (
                              invoice?.classes?.map((all, i) => {
                                return (
                                  <h4 className="key-pair-value text-align-left" key={i}>{`${all?.name || "--/--"}`}</h4>
                                );
                              })
                            ) : null}
                          </h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Created On</p>
                          <h4>{invoice?.created_at || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Due On</p>
                          <h4>{invoice?.due_date || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className="page-content padding-equal margin-bottom-14">
                  <Grid container spacing={3}>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                      <PaymentCard
                        title="No. of Student Sent To"
                        count={invoice?.no_students_sent_to || 0}
                        icon={<Icon icon="hugeicons:sent" width="20" height="20" />}
                      />
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                      <PaymentCard
                        title="No. of Student Paid"
                        count={invoice?.no_students_paid || 0}
                        icon={<Icon icon="mdi:credit-card-check" width="20" height="20" />}
                      />
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                      <PaymentCard
                        title="No. of Student Unpaid"
                        count={invoice?.no_students_unpaid || 0}
                        icon={<Icon icon="mdi:credit-card-remove" width="20" height="20" />}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className="page-content padding-equal margin-bottom-14">
                  <Table data={searchResult} handleRowSelected={handleRowSelected} columns={columns} subHeader={true} pagination isLoading={isLoading}
                    subHeaderComponent={
                      studentinvoice?.length > 0 && (
                        <div className="action_div">
                          <TableSearch placeholder="Search here..." searchTableFunc={handleSearchStudentInvoice} />
                          <div>
                            {(invoice?.total_amount_paid === 0 && invoice?.structure_type !== "student" && !(invoice?.total_discount > 0)) && (
                              <Button onClick={handleDiscountModal} variant="primary" buttonSize="medium" color="btndefault" buttonName="Apply Discount" />
                            )}
                          </div>
                        </div>
                      )
                    }
                  />
                </div>
                <div className="page-content padding-equal margin-bottom-14">
                  <div className={`${classes.previewsubheader} text-align-left margin-top-16 `}>
                    <div>
                      <h4>Description:</h4>
                      <p>{invoice?.description || "--/--"}</p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <Modal
            title="Cancel"
            subtitle={
              <div>
            Are you sure you want to cancel ?
              </div>
            }
            modalContent={<></>}
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="dangeroutline"
                    buttonSize="full"
                    color="btndanger"
                    buttonName="Go Back"
                    onClick={handleCloseCancelModal}
                  />
                  <Button
                    variant="danger"
                    buttonName="Yes, Cancel"
                    buttonSize="full"
                    color="btndefault"
                    onClick={() => navigate("/payment/overview")}
                  />
                </div>
              </>
            }
            isopen={cancelModal}
            closeModal={handleCloseCancelModal}
          />
          <Modal
            title="Apply Discount"
            subtitle={
              <div>
      You are about to assign a discount to {selectedInvoices.length} selected invoice(s)
              </div>
            }
            modalContent={
              <>
                {/* Selected Invoices Display */}
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={classes.selectedInvoices}>
                      {selectedInvoices?.length > 0 ? (
                        <>
                          <h4>Selected Invoices ({selectedInvoices?.length})</h4>
                          <div className={classes.invoiceList}>
                            {selectedInvoices?.map((invoiceNo, index) => (
                              <span key={index} className={classes.invoiceTag}>
                                {invoiceNo}
                              </span>
                            ))}
                          </div>
                        </>
                      ) : (
                        <div className={classes.noSelection}>
                          <p>Please select invoice(s) from the table to apply discount</p>
                        </div>
                      )}
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Select Discount"
                      required
                      children={
                        <select
                          name="discount_id"
                          onChange={(e) => {
                            const discount = discountItems.find(d => d?.id === e.target.value);
                            if (discount) {
                              setSelectedDiscount(discount);
                            }
                          }}
                        >
                          <option value="">{isGettingDiscounts ? "Please wait..." : "--Select--"}</option>
                          {discountItems?.map((discount) => {
                            return (
                              <option key={discount?.id} value={discount?.id}>
                                {discount?.name} - {discount?.value}%
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button
                  variant="primary"
                  buttonName="Apply"
                  buttonSize="full"
                  color="btndefault"
                  onClick={handleApplyDiscount}
                  disabled={!selectedDiscount || selectedInvoices.length === 0}
                />
              </>
            }
            isopen={discountModal}
            closeModal={handleDiscountModal}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default PreviewInvoice;
